export const FAQ_CATEGORIES = ['FAQ', 'Service', 'Account', 'Trading', 'Social', 'Safety', 'Account deletion', 'Bettie']